module.exports = __webpack_public_path__ + "img/question.8bcee2f5.jpg";